import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import route from 'ziggy-js';
import { Ziggy } from '@/ziggy';
import Error from './Pages/Errors/Error';

Ziggy.url = import.meta.env.VITE_APP_URL || window?.location?.origin;

createInertiaApp({
    title: (title) => title ?? 'yhangry - book a private chef for any occasion',
    resolve: (name) => {
        try {
            const pages = import.meta.glob('./Pages/**/*.{jsx,tsx}', {
                eager: false,
            });

            const page =
                pages[`./Pages/${name}.tsx`] || pages[`./Pages/${name}.jsx`];

            if (!page) {
                throw new Error(`Page ${name} not found`);
            }

            return page();
        } catch (error) {
            return () => <Error />;
        }
    },
    setup({ el, App, props }) {
        global.route = (name, params, absolute, config = Ziggy) =>
            route(name, params, absolute, config);
        global.locale = props?.initialPage?.props?.init?.locale ?? {};
        createRoot(el).render(<App {...props} />);
    },
    progress: {
        color: '#FF6854',
    },
});
